import React from 'react'

export default {
  home: 'Hello',
  switchLang: '中文',
  header: {
    button: 'Register Now',
    slogan: 'TOWER 5 – NEW HOMES COMING SOON'
  },
  invest:<>
    <h5>THE AMAZING BRENTWOOD BY SHAPE<br/><span>TOWER 5 COMING SOON</span></h5>
    <p>The wait was worth it. The Amazing Brentwood has come to real life as Metro Vancouver’s most celebrated urban destination. Over $600 million in wealth was created for homeowners in Neighbourhood One. Now, Tower 5 – the first real estate opportunity in over six years - will anchor Neighbourhood Two.</p>
  </>,
  stories: {
    card1: {
      title: 'Tower 5: Our Best Real Estate Offering to Date',
      content: 'SkyTrain at your doorstep, The Amazing Brentwood at your feet. Never has an address enjoyed such bragging rights. Set slightly back from the bustling core with soaring mountain and water views, Tower 5 sits in the site’s most coveted location steps from the energy and action of Neighbourhood One, with front-row seats to the highly anticipated Neighbourhood Two.',
      caption: 'Tower 5: Our Best Real Estate Offering To Date'
    },
    card2: {
      title: 'TOWER 5: CONNECTED TO TRANSIT AND A MARKET LEADING RETAIL EXPERIENCE',
      content: 'A decade in the making with over $1.2 billion invested in Neighbourhood One, The Amazing Brentwood is changing the landscape of Metro Vancouver. Phase 1 boasts 3 completed residential towers, 400,000sf of retail, a central plaza with events, art, and culture, and a curated collection of retailers including BC’s first location of The Rec Room and H&M Home, Cineplex VIP, Sephora, Nike, Adidas, Earls, Tap & Barrel, HaiDiLao Hotpot, LL Bean, La Taqueria, Small Victory Bakery, and Bella Gelateria. With all of this downstairs and new shops and restaurants to come in Neighbourhood Two, residents will be VIPs in Metro Vancouver’s hottest new destination.',
      caption: 'Neighbourhood One'
    },
    card3: {
      title: 'TOWER 5: Revolutionary new home design to be unveiled',
      content: 'The signature SHAPE home, renowned for its unparalleled function and timeless design, has been reimagined to take your living experience to the next level. Future-forward features and revolutionary layouts that will redefine urban living. Soaring views in every direction. A 10,000 SF private amenity facility with the best in fitness, entertainment and well-being. No other home offers a return on lifestyle like this.',
      caption: 'New SHAPE Kitchen Design'
    }
  },
  register: {
    title: [
      'register',
      ' your interest',
      'in tower 5 today.'
    ],
    form: {
      firstName: 'First Name*',
      lastName: 'Last Name*',
      email: 'Email*',
      phone: 'Phone*',
      postalCode: 'Postal Code*',
      country: 'Country',
      hearAbout: 'How did you hear about us? *',
      isRealtor: 'Are you a Realtor? *',
      isRealtorEmployer: 'Employer/Brokerage *',
      isWorkingWithRealtor: 'Are you working with a Realtor?',
      isWorkingWithRealtorName: 'Realtor Name',
      isWorkingWithRealtorEmail: 'Realtor Email*',
      isWorkingWithRealtorBrokerage: 'Realtor Brokerage',
      isHomeownerAtTAB: 'Are you a retailer/Tower One market rental tenant/current homeowner at The Amazing Brentwood (please select one)?*',
      isTABRetailer: 'Are you a Retailer at The Amazing Brentwood?',
      isTABTenant: 'Are you a Rental Tenant at The Amazing Brentwood?',
      isTABHomeowner: 'Are you a Homeowner at The Amazing Brentwood?',
      questionSelections: {
        hearAbout: {
          id: 'answers[3038][answers]',
          options: [
            {
              value: 'Email Outreach',
              content: 'Email Outreach'
            },
            {
              value: 'Facebook',
              content: 'Facebook'
            },
            {
              value: 'Friends and Family',
              content: 'Friends and Family'
            },
            {
              value: 'Instagram',
              content: 'Instagram'
            },
            {
              value: 'MLS',
              content: 'MLS'
            },
            {
              value: 'Online Search',
              content: 'Online Search'
            },
            {
              value: 'Print Publication',
              content: 'Print Publication'
            },
            {
              value: 'Realtor',
              content: 'Realtor'
            },
            {
              value: 'Signage/Walk- or Drive-by',
              content: 'Signage/Walk- or Drive-by'
            },
            {
              value: 'WeChat',
              content: 'WeChat'
            },
            {
              value: 'Other',
              content: 'Other'
            },
          ]

        },
        isRealtor: {
          id: 'agent',
          options: [
            {
              value: 'false',
              content: 'No'
            },
            {
              values: 'true',
              content: 'Yes'
            }
          ]
        },
        isWorkingWithRealtor: {
          id: 'answers[8454][answers]',
          options: [
            {
              value: 'No',
              content: 'No'
            },
            {
              values: 'Yes',
              content: 'Yes'
            }
          ]
        },
        isOrWorkingWithRealtor: {
          id: 'isOrWorkingWithRealtor',
          options: [
            {
              value: 'Yes, I am realtor',
              content: 'Yes, I am realtor'
            },
            {
              values: 'No, I am not a realtor',
              content: 'No, I am not a realtor'
            },
            {
              value: 'Yes, I am working with a realtor',
              content: 'Yes, I am working with a realtor'
            },
            {
              values: 'No, I am not working with a realtor',
              content: 'No, I am not working with a realtor'
            }
          ]
        },
        isHomeownerAtTAB: {
          id: 'isHomeownerAtTAB',
          options: [
            {
              value: 'No, none of the above',
              content: 'No, none of the above'
            },
            {
              values: 'Yes, I am retailer',
              content: 'Yes, I am retailer'
            },
            {
              value: 'Yes, I am a Tower One market rental tenant',
              content: 'Yes, I am a Tower One market rental tenant'
            },
            {
              values: 'Yes, I am a current homeowner',
              content: 'Yes, I am a current homeowner'
            }
          ]
        },
        isTABRetailer: {
          id: 'answers[8553][answers]',
          options: [
            {
              value: 'No',
              content: 'No'
            },
            {
              values: 'Yes',
              content: 'Yes'
            }
          ]
        },
        isTABTenant: {
          id: 'answers[8557][answers]',
          options: [
            {
              value: 'No',
              content: 'No'
            },
            {
              values: 'Yes',
              content: 'Yes'
            }
          ]
        },
        isTABHomeowner: {
          id: 'answers[9501][answers]',
          options: [
            {
              value: 'No',
              content: 'No'
            },
            {
              values: 'Yes',
              content: 'Yes'
            }
          ]
        },
        reasonForPurchase: {
          id: 'reasonForPurchase',
          options: [
            {
              value: 'Principal Residence',
              content: 'Principal Residence'
            },
            {
              values: 'Investment',
              content: 'Investment'
            },
            {
              values: 'For Family',
              content: 'For Family'
            }
          ]
        }
        ,
        numberOfHomesRequested: {
          id: 'numberOfHomesRequested',
          options: [
            {
              value: '1',
              content: '1'
            },
            {
              values: '2',
              content: '2'
            },
            {
              values: '3+',
              content: '3+'
            }
          ]
        },
        numberOfBuyers: {
          id: 'numberOfBuyers',
          options: [
            {
              value: '1',
              content: '(1) One - only me'
            },
            {
              values: '2',
              content: '(2) Two - myself and one other'
            },
            {
              values: '3',
              content: '(3) Three - myself and two others'
            },
            {
              values: '4',
              content: '(4) Four - myself and three others'
            },
            {
              values: 'unsure',
              content: 'I’m unsure at the moment'
            }
          ]
        }
        ,
        colourScheme: {
          id: 'colourScheme',
          options: [
            {
              value: '1',
              content: 'option 1'
            },
            {
              values: '2',
              content: 'option 2'
            }
          ]
        },
        homeOptionOneBeds: {
          id: 'homeOptionOneBeds',
          options: [
            {
              value: 'Studio',
              content: 'Studio'
            },
            {
              values: '1 BR',
              content: '1 BR'
            },
            {
              values: '1 BR + D',
              content: '1 BR + D'
            },
            {
              values: '2 BR',
              content: '2 BR'
            },
            {
              values: '2 BR + D',
              content: '2 BR + D'
            },
            {
              values: '3 BR',
              content: '3 BR'
            },
            {
              values: '3 BR + D',
              content: '3 BR + D'
            },
            {
              values: '4 BR ',
              content: '4 BR'
            }
          ]
        },
        isPermanentResident: {
          id: 'isPermanentResident',
          options: [
            {
              value: 'IS',
              content: 'Yes'
            },
            {
              values: 'IS NOT',
              content: 'No'
            }
          ]
        },
        isForeignEntity: {
          id: 'isForeignEntity',
          options: [
            {
              value: 'IS',
              content: 'Yes'
            },
            {
              values: 'IS NOT',
              content: 'No'
            }
          ]
        }
      },
      checkKeepMe: 'I CONSENT TO RECEIVING VIP EARLY ACCESS FOR COMMUNITIES MARKETED BY SHAPE MARKETING CORP. and to receiving electronic communications from Shape Marketing Corp. with respect to such communities. I may withdraw my consent at anytime by email to info@shapeproperties.com or by post to 3100 - 1090 Pender Street W., Box 315, Vancouver, BC, Canada V6E 0E3.',
      submit: 'Submit',
      distclaimer: 'This is not an offering for sale as an offer can only be made when accompanied by a disclosure statement E. & O.E. Sales and Marketing by Shape Marketing.',
    },
  },
  footer: {
    title: <>New Presentation Centre and<br />Show Homes Coming Soon</>,
    address: '4567 LOUGHEED HWY, BURNABY',
    phone: '604.563.8386',
    email: 'info@theamazingbrentwood.com',
    rental: 'Rental Homes',
    shoppingCentre: 'Shopping Centre',
    privacyPolicy: 'privacy policy',
    at: '@the.amazing.brentwood',
  }
};
